define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/comm",
	"csi/xml"
], function(declare,EditController,comm,xml) {

	var COLOR_SPEC = "ColorSpecification";

	return declare(EditController, {
		toWriter: function() {
			// summary: create color spec if specified
			if (this.m_formData.getFieldValue("CreateColorSpecification")) {
				// need the value of the field with path "Child:ColorSpecification" - since the form is dynamic
				// it's not obvious how to get to it directly by index
				var newColorSpecName = null;
				this.m_formData.getFields().forEach(function (f) {
					if (f.m_path == "Child:ColorSpecification")
						newColorSpecName = f.getValue();
				});

				if (newColorSpecName) {
					var newColorSpecURL = comm.createUrl();
					this.m_writer.createNode(newColorSpecURL, COLOR_SPEC);
					this.m_writer.changeNode(this.m_urlNode).changeAttribute(COLOR_SPEC, xml.ATTR_REF, newColorSpecURL);
				}
			}

			return this.inherited(arguments);
		}
	});
});